import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { sessionService } from 'redux-react-session';
import { BrowserRouter } from 'react-router-dom';
import Appsignal from '@appsignal/javascript';
import { ErrorBoundary } from '@appsignal/react';
import { appsignalApiKey } from 'apis';
// Material-UI
import { ThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider  } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import './index.css';
// Store
import store from './features/store';
// Components
import ErrorSnackbar from 'components/Common/Feedback/ErrorSnackbar/ErrorSnackbar';
import SuccessSnackbar from 'components/Common/Feedback/SuccessSnackbar/SuccessSnackbar';
import App from 'components/App/App';

const container = document.getElementById('root');
const root = createRoot(container);
const appsignal = new Appsignal({ key: appsignalApiKey });
sessionService.initSessionService(store);

root.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
       <ErrorSnackbar />
        <SuccessSnackbar />
        <BrowserRouter>
          <ErrorBoundary instance={appsignal}>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.unregister();

    if (caches) {
      // Service worker cache should be cleared with caches.delete()
      caches.keys().then(async (names) => {
        await Promise.all(names.map(name => caches.delete(name)));
      });
    }
  });
}